import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { CanComponentDeactivate } from '@app/core/auth/can-component-deactivate.interface';
import { OnlineStoreFormWrapperComponent } from '../components/online-store-form-wrapper/online-store-form-wrapper.component';
import { 
  OnlineStoreFormConfig,
  ONLINE_STORE_FORM_CONFIG
} from '../online-store.config';

@Component({
  selector: 'app-online-store-add',
  standalone: true,
  imports: [OnlineStoreFormWrapperComponent],
  templateUrl: './online-store-add.component.html',
  styleUrls: ['./online-store-add.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnlineStoreAddComponent implements CanComponentDeactivate {
  @ViewChild('formWrapper') private readonly formWrapper?: OnlineStoreFormWrapperComponent;

  config: OnlineStoreFormConfig = {
    title: 'onlineStore.form.add_online_store',
    formFields: ONLINE_STORE_FORM_CONFIG.formFields,
    sectionButtons: ONLINE_STORE_FORM_CONFIG.sectionButtons,
    headerActions: ONLINE_STORE_FORM_CONFIG.headerActions,
    listRoute: '/channel/online-store'
  };

  canDeactivate(): boolean {
    return this.formWrapper?.canDeactivate() ?? true;
  }
}
